import React from 'react'
import { Card, Accordion } from 'react-bootstrap';

export default function Step6Pleated({
  ContextAwareToggle,
  requiredStep,
  stepSelectedLabel,
  setDeps,
  setCart,
  t,
  isTabletOrMobile,
  step4,
  setStep4,
  selectChanged,
  inputs,
  liningPrice,
  popoverImages,
  popoverThumbnailHover,
  NextStep,
  GetPrice,
  PopoverStickOnHover,
  pageLanguage,
  step5
}) {
  return (
   <Card>
   <Card.Header>
     <ContextAwareToggle
       eventKey="4"
       stepNum={t("6")}
       stepTitle={t("grommet_step4_Drapery")}
       stepRef="4"
       type="1"
       required={requiredStep["4"]}
       stepSelected={stepSelectedLabel["4"] === undefined ? "" : stepSelectedLabel["4"]}
     />
   </Card.Header>
   <Accordion.Collapse eventKey="4">
     <Card.Body>
       <div className="card_body card_body_radio tall_img_card_body">
         <div className="box50 radio_style">
           <input
             className="radio"
             type="radio"
             text={t("Standard Lining")}
             value="1"
             name="step4"
             ref-num="4"
             id="41"
             checked={step4 === "Standard Lining"}
             onChange={(e) => {
               setStep4("Standard Lining");
               setDeps("", "4");
               setCart("Lining", "Standard Lining");
               selectChanged(e);
             }}
             ref={(ref) => (inputs.current["41"] = ref)}
           />
           <label htmlFor="41">
             {t("Standard Lining")}
             <br />
             <p className="surcharge_price">{t("No Additional Charge")}</p>
           </label>
         </div>
         <div className="box50 radio_style">
           <input
             className="radio"
             type="radio"
             text={t("Privacy Lining")}
             value="2"
             name="step4"
             ref-num="4"
             id="42"
             checked={step4 === "Privacy Lining"}
             onChange={(e) => {
               setStep4("Privacy Lining");
               setDeps("", "4");
               setCart("Lining", "Privacy Lining");
               selectChanged(e);
             }}
             ref={(ref) => (inputs.current["42"] = ref)}
           />
           <label htmlFor="42">
             {t("Privacy Lining")}
             <br />
             <p className="surcharge_price">
               {liningPrice !== undefined
                 ? liningPrice !== 0
                   ? t("Add ") +
                     GetPrice(liningPrice, pageLanguage, t("TOMANS"), isTabletOrMobile)
                   : t("Surcharge Applies")
                 : t("Surcharge Applies")}
             </p>
           </label>
         </div>

         <NextStep currentStep="4" eventKey={ step5 === "Full" ? "6" : "5"}>
           {t("NEXT STEP")}
         </NextStep>
       </div>
       <div className="accordion_help">
         <div className="help_container">
           <div className="help_column help_left_column">
             <p className="help_column_header">{t("grommet_lining_help_1")}</p>
             <ul className="help_column_list">
               <li className="no_listStyle">
                 <span className="popover_indicator">
                   {
                     <PopoverStickOnHover
                       placement={`${pageLanguage === "fa" ? "right" : "left"}`}
                       children={
                         <object
                           className="popover_camera"
                           type="image/svg+xml"
                           data={require("../../Images/public/camera.svg").default}
                         />
                       }
                       component={
                         <div className="clearfix">
                           <div className="popover_image clearfix">
                             <img
                               src={
                                 popoverImages["step41"] === undefined
                                   ? require("../../Images/drapery/grommet/standard_lining.jpg")
                                   : popoverImages["step41"]
                               }
                               className="img-fluid"
                               alt=""
                             />
                           </div>
                           <div className="popover_footer">
                             <span className="popover_footer_title">
                               {t("grommet_lining_help_1")}
                             </span>
                             <span className="popover_thumbnails">
                               <div>
                                 <img
                                   src={require("../../Images/drapery/grommet/standard_lining.jpg")}
                                   text="step41"
                                   onMouseEnter={(e) => popoverThumbnailHover(e)}
                                   className="popover_thumbnail_img img-fluid"
                                   alt=""
                                 />
                               </div>
                             </span>
                           </div>
                         </div>
                       }
                     />
                   }
                 </span>
                 {t("grommet_lining_help_2")}
               </li>
               <li>{t("grommet_lining_help_3")}</li>
               <li>{t("grommet_lining_help_4")}</li>
             </ul>
           </div>
           <div className="help_column help_right_column">
             <p className="help_column_header">{t("grommet_lining_help_5")}</p>
             <ul className="help_column_list">
               <li className="no_listStyle">
                 <span className="popover_indicator">
                   {
                     <PopoverStickOnHover
                       placement={`${pageLanguage === "fa" ? "right" : "left"}`}
                       children={
                         <object
                           className="popover_camera"
                           type="image/svg+xml"
                           data={require("../../Images/public/camera.svg").default}
                         />
                       }
                       component={
                         <div className="clearfix">
                           <div className="popover_image clearfix">
                             <img
                               src={
                                 popoverImages["step42"] === undefined
                                   ? require("../../Images/drapery/grommet/privacy_lining.jpg")
                                   : popoverImages["step42"]
                               }
                               className="img-fluid"
                               alt=""
                             />
                           </div>
                           <div className="popover_footer">
                             <span className="popover_footer_title">
                               {t("grommet_lining_help_5")}
                             </span>
                             <span className="popover_thumbnails">
                               <div>
                                 <img
                                   src={require("../../Images/drapery/grommet/privacy_lining.jpg")}
                                   text="step42"
                                   onMouseEnter={(e) => popoverThumbnailHover(e)}
                                   className="popover_thumbnail_img img-fluid"
                                   alt=""
                                 />
                               </div>
                             </span>
                           </div>
                         </div>
                       }
                     />
                   }
                 </span>
                 {t("grommet_lining_help_6")}
               </li>
               <li>{t("grommet_lining_help_7")}</li>
               <li>{t("grommet_lining_help_8")}</li>
             </ul>
           </div>
         </div>
       </div>
     </Card.Body>
   </Accordion.Collapse>
 </Card>
  )
}
